var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 46,
    viewBox: "0 0 138 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11276_16065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5965 45.5525H6.40364C4.20123 45.5525 2.71341 43.3044 3.57421 41.2771L11.0913 23.5741C11.2734 23.0617 11.2574 22.769 11.2574 22.769H15.372C15.367 23.1192 15.3072 23.3541 15.1524 23.7244L7.86005 40.959C7.6967 41.3451 7.98009 41.7727 8.39927 41.7727H13.9495C15.0653 41.7727 16.0731 41.1058 16.5093 40.0788L27.4208 14.389C29.1843 10.237 35.0651 10.2259 36.8443 14.3712L37.6214 16.182L35.499 20.9392L34.0038 17.445C33.2934 15.7848 30.9385 15.7883 30.2332 17.4507L19.3695 43.0548C18.727 44.5691 17.2414 45.5525 15.5965 45.5525Z",
    fill: "url(#paint0_radial_11276_16065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5965 0.000640869H6.40364C4.20123 0.000640869 2.71341 2.24879 3.57421 4.27602L11.0913 21.9791C11.2734 22.4914 11.2574 22.7842 11.2574 22.7842H15.372C15.367 22.434 15.3072 22.1991 15.1524 21.8288L7.86005 4.59411C7.6967 4.20806 7.98009 3.78044 8.39927 3.78044H13.9495C15.0653 3.78044 16.0731 4.44733 16.5093 5.47436L22.9848 20.7201L25.0514 15.8897L19.3695 2.49836C18.727 0.984083 17.2414 0.000640869 15.5965 0.000640869Z",
    fill: "url(#paint1_radial_11276_16065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0811 29.2022L28.8814 24.9057L30.2574 28.1114C30.96 29.7508 33.2874 29.7654 34.0193 28.126L40.8991 12.5221C41.0455 12.2 41.47 12.1708 41.6603 12.4489L43.6071 15.3618C43.6949 15.4789 43.7096 15.6399 43.651 15.7863L37.1225 30.7901C35.2928 34.9911 29.2913 34.8594 27.6519 30.5851L27.0811 29.2022Z",
    fill: "#8952E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4691 25.0664L39.3906 29.8969L41.1326 34.2445C41.279 34.5958 41.762 34.6104 41.9377 34.2591L43.6942 30.6289C43.7528 30.5118 43.7528 30.3801 43.6942 30.263L41.4691 25.0664Z",
    fill: "#2DD1DA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.958 16.7386C85.5199 16.7386 86.8553 17.0781 87.9645 17.7572C89.0962 18.4363 89.9564 19.3983 90.5449 20.6432C91.1561 21.8655 91.4616 23.3029 91.4616 24.9553V26.7548H79.0009C79.0461 28.8146 79.5667 30.3878 80.5627 31.4742C81.5813 32.5381 82.996 33.07 84.8068 33.07C85.9612 33.07 86.9798 32.9682 87.8626 32.7645C88.768 32.5381 89.6961 32.2212 90.6468 31.8138V34.4282C89.7187 34.8356 88.802 35.1299 87.8966 35.3109C86.9912 35.5147 85.916 35.6165 84.671 35.6165C82.9507 35.6165 81.4228 35.2657 80.0874 34.564C78.7745 33.8623 77.7446 32.8211 76.9976 31.4403C76.2733 30.0369 75.9111 28.3279 75.9111 26.3134C75.9111 24.3215 76.2393 22.6125 76.8958 21.1865C77.5748 19.7604 78.5142 18.6626 79.7139 17.893C80.9362 17.1234 82.3509 16.7386 83.958 16.7386ZM83.9241 19.1832C82.498 19.1832 81.3663 19.6473 80.5288 20.5753C79.7139 21.4807 79.2272 22.7483 79.0688 24.3781H88.338C88.338 23.3368 88.1795 22.4314 87.8626 21.6618C87.5457 20.8922 87.0591 20.2924 86.4026 19.8623C85.7688 19.4096 84.9427 19.1832 83.9241 19.1832Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 35.277H97.7618V9.47266H100.75V35.277Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.17 17.0781V35.277H108.183V17.0781H111.17ZM109.71 10.2536C110.163 10.2536 110.559 10.412 110.899 10.7289C111.261 11.0232 111.442 11.4985 111.442 12.1549C111.442 12.7887 111.261 13.2641 110.899 13.581C110.559 13.8979 110.163 14.0563 109.71 14.0563C109.212 14.0563 108.794 13.8979 108.454 13.581C108.115 13.2641 107.945 12.7887 107.945 12.1549C107.945 11.4985 108.115 11.0232 108.454 10.7289C108.794 10.412 109.212 10.2536 109.71 10.2536Z",
    fill: "#202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.29 17.127L122.571 26.0227L115.984 35.3258H119.346L124.371 28.0598L129.328 35.3258H132.723L126.102 26.0227L124.371 23.6155L119.685 17.127H116.29Z",
    fill: "#202020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.305 17.127H128.866L125.206 22.2502L126.889 24.5922L132.305 17.127Z",
    fill: "#8952E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3784 35.3742H69.1178V23.3205H55.8582V35.3742H52.5977V9.5293H55.8582V20.4609H69.1178V9.5293H72.3784V35.3742Z",
    fill: "#202020"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11276_16065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0299 22.769) rotate(113.091) scale(20.5274 8.63299)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7174DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#7170DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD1DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11276_16065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5422 22.1108) rotate(-27.8241) scale(5.95851 8.52149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7172DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#736FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8952E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11276_16065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.5236,
    height: 45.5236,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.75a7c7ad8bd0ec3bafa065a6198d3194.svg";
export { ForwardRef as ReactComponent };